<template>
  <div class="smart-textbox">
    <textarea-autosize
      ref="textarea"
      :class="{ 'field-value': true, safetyPadding: !!emojis || !!examples }"
      v-model="valueLocal"
      :disabled="disabled"
      :placeholder="placeholder"
    ></textarea-autosize>

    <div
      v-if="emojis && !disabled"
      :class="{ toggle_emoji_picker: true, openned: showEmojiPicker }"
      @click="emojiPickerToggle"
    >
      <i class="far fa-laugh"></i>
    </div>
    <div v-if="emojis" :class="{ emojipicker: true, hidden: !showEmojiPicker }">
      <VEmojiPicker
        :showSearch="false"
        :emojiWithBorder="false"
        @select="emojiPickerSelect"
      />
    </div>

    <div
      v-if="examples && !disabled"
      :class="{ examples_toggle: true, openned: showExamples }"
      @click="examplesToggle"
    >
      <i class="far fa-book"></i>
    </div>
    <div
      v-if="examples"
      :class="{ examples_popup: true, hidden: !showExamples }"
    >
      <div class="example_categories">
        <div
          :class="{
            example_category: true,
            selected: exmplsSelectedCategory == category.name,
          }"
          v-for="(category, i) in exmpls[examples].categories"
          :key="i"
          @click="examplesSelectCategory(category.name)"
        >
          <div class="category_icon">
            <i :class="{ fas: true, [category.icon]: true }"></i>
          </div>
          <div class="category_name">
            {{ category.name }}
          </div>
        </div>
      </div>
      <div class="example_texts">
        <div
          class="example_text"
          v-for="(example, i) in exmpls[examples].examples"
          :key="i"
          v-show="example.category == exmplsSelectedCategory"
        >
          <div class="put_example" @click="examplePutToValue(example.text)">
            <i class="fas fa-reply"></i>
          </div>
          <div class="text">{{ example.text }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let examples = {
  "card-backfields": {
    categories: [
      { name: "Контакты", icon: "fa-address-book" },
      { name: "Правила", icon: "fa-book-open" },
    ],
    examples: [
      {
        text: `📍 г. Москва, ул. Пушкина, 14
⏰ ВС-ЧТ: с 12:00 до 00:30
⏰ ПТ-СБ: с 12:00 до 06:00
📞 +7 (999) 999-88-77

<a href='https://www.instagram.com/_ACCOUNTLINK_/'>Instagram</a>`,
        category: "Контакты",
      },
      {
        text: `🔞 Вход строго с 18 лет!
📍 г. Москва, ул. Пушкина, 14
📞 +7 (999) 999-88-77
🌚 Работаем для вас 24/7!
`,
        category: "Контакты",
      },
      {
        text: `С помощью нашей карты вы можете накапливать бонусы в нашем заведении, которыми вы сможете оплатить до 50% от счёта 😏
Процент начислений бонусов зависит от потраченных средств и изменяется по следующим условиям:

👉 3% - спасибо за регистрацию!
👉 5% - при сумме покупок от 30.000₽
👉 7% - при сумме покупок от 60.000₽
🤘 10% - при сумме покупок от 100.000₽ + подарок!`,
        category: "Правила",
      },
      {
        text: `С помощью нашей карты вы можете получать скидки в нашем заведении! 😏
Процент скидки зависит от потраченных средств и изменяется по следующим условиям:

👉 3% - добро пожаловать!
👉 5% - при сумме покупок от 30.000₽
👉 7% - при сумме покупок от 60.000₽
🤘 10% - при сумме покупок от 100.000₽`,
        category: "Правила",
      },
      {
        text: `🌟 500 бонусов получает любой гость при регистрации в програме лояльности! 

Получайте на свой бонусный счет процент от своих покупок. Размер начисляемых бонусов соответствует тратам гостя:
До 15.000₽ - 3%
До 30.000₽ - 5%
До 100.000₽ - 10%
От 200.000₽ - 15%

Гость может оплатить бонусами максимум 20% от счёта.`,
        category: "Правила",
      },
      {
        text: "🎂 Также у нас действует скидка в День Рождения - 15%",
        category: "Правила",
      },
      { text: "😉 Кстати, каждый 5й кальян в подарок!", category: "Правила" },
    ],
  },
};

export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    disabled: {
      default: false,
    },
    emojis: {
      default: false,
    },
    examples: {
      default: "",
    },
    placeholder: {
      default: "",
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  computed: {
    valueLocal: {
      get: function () {
        return this.value;
      },
      set: function (v) {
        this.$emit("change", v);
      },
    },
  },
  data() {
    return {
      showEmojiPicker: false,
      showExamples: false,
      exmpls: examples,
      exmplsSelectedCategory: "",
    };
  },
  methods: {
    emojiPickerToggle() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    emojiPickerSelect(emoji) {
      console.log("emojiPickerSelect");
      const textarea = this.$refs.textarea.$el;
      // console.log(textarea, this.$refs);
      const cursorPosition = textarea.selectionEnd;
      const start = this.valueLocal.substring(0, textarea.selectionStart);
      const end = this.valueLocal.substring(textarea.selectionStart);
      const text = start + emoji.data + end;
      console.log(cursorPosition, start, end, text);
      this.valueLocal = text;
      textarea.focus();
      this.$nextTick(() => {
        textarea.selectionEnd = cursorPosition + emoji.data.length;
      });
    },
    examplesToggle() {
      this.showExamples = !this.showExamples;
      if (this.showExamples) {
        this.exmplsSelectedCategory =
          this.exmpls[this.examples].categories[0].name;
      }
    },
    examplesSelectCategory(name) {
      this.exmplsSelectedCategory = name;
    },
    examplePutToValue(text) {
      if (this.valueLocal == "") {
        this.valueLocal += text;
      } else {
        this.valueLocal += "\n" + text;
      }
      this.examplesToggle();
    },
  },
};
</script>

<style lang="stylus" scoped>
.smart-textbox {
  position: relative;
}

.smart-textbox .field-value {
  width: calc(100% - 15px);
  border: 1px solid rgb(238, 238, 238);
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 10px;
  border-radius: 4px;
  margin-top: 0px;
  margin-bottom: 0px;
  height: 55px;
  outline: none;
  padding: 5px 10px;

  &.safetyPadding {
    padding-right: 25px;
  }

  &:hover, &:focus {
    border: 1px solid gray;
  }

  &[disabled] {
    background: #f7f7f7;
    box-shadow: none;
    border: none;
  }
}

.emojipicker {
  position: absolute;
  margin-left: -325px;
  margin-top: 5px;
  right: 15px;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
  z-index: 3;

  &.hidden {
    display: none;
  }
}

.toggle_emoji_picker {
  position: absolute;
  right: 23px;
  top: 2px;
  cursor: pointer;
  opacity: 0.4;

  &:hover {
    opacity: 1;
  }

  &.openned {
    color: #4caf50;
    opacity: 1;
  }
}

.examples_popup {
  background: white;
  position: absolute;
  margin-left: -325px;
  margin-top: 5px;
  right: 15px;
  box-shadow: 0 20px 20px rgba(0, 0, 0, 0.1);
  z-index: 2;
  border: 1px solid #eee;
  border-radius: 10px;
  color: black;

  &.hidden {
    display: none;
  }
}

.examples_toggle {
  position: absolute;
  right: 23px;
  bottom: 9px;
  cursor: pointer;
  opacity: 0.4;

  &:hover {
    opacity: 1;
  }

  &.openned {
    color: #4caf50;
    opacity: 1;
  }
}

.example_categories {
  text-align: center;
  padding-top: 5px;
  margin-bottom: 5px;

  .example_category {
    display: inline-block;
    margin-right: 5px;
    margin-left: 5px;
    padding-bottom: 5px;
    padding-left: 5px;
    padding-right: 5px;
    border-bottom: 1px solid #eee;
    cursor: pointer;

    &:hover {
      border-bottom: 1px solid gray;
    }

    &.selected {
      border-bottom: 1px solid gray;
    }

    .category_icon {
      display: inline-block;
      width: 30px;
      text-align: center;
    }

    .category_name {
      display: inline-block;
    }
  }
}

.example_texts {
  width: 350px;
  overflow: hidden;
  overflow-y: scroll;
  max-height: 350px;

  .example_text {
    position: relative;
    padding: 5px;
    word-break: break-word;
    background: #f7f7f7;
    border-radius: 4px;
    margin: 0 10px;
    margin-bottom: 5px;
    white-space: pre-line;

    &:hover {
      background: #eee;
    }

    .put_example {
      position: absolute;
      top: 3px;
      left: 7px;
      display: inline-block;
      color: #bfbfbf;
      cursor: pointer;

      &:hover {
        color: black;
      }
    }

    .text {
      position: relative;
      left: 20px;
      display: inline-block;
      width: calc(100% - 20px);
    }
  }
}

@media only screen and (max-width: 600px) {
  .toggle_emoji_picker {
    display: none !important;
  }

  .examples_popup {
    right: unset;
    left: 50%;
    transform: translateX(-50%);
    margin-left: -35px;
  }
}

@media (prefers-color-scheme: dark) {
  .smart-textbox .field-value {
    background: #1e1e1e;
    color: white;
    border-color: #444444;
  }
}
</style>